// src/pages/BusinessListing.jsx
import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Swal from "sweetalert2";
import API_BASE from "../config/api";
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { useNavigate } from "react-router-dom";


function BusinessListing() {
    const navigate = useNavigate();
    const userData = JSON.parse(localStorage.getItem("user"));
    useEffect(() => {
        const user = localStorage.getItem("user");

        if (!user) {
            Swal.fire({
                icon: "info",
                title: "Login Required",
                text: "Before listing your business, you must Login or Register.",
                confirmButtonText: "Okay",
            }).then(() => {
                navigate("/login", { replace: true });
            });
        }
    }, []);
    const [step, setStep] = useState(1);
    const [successMsg, setSuccessMsg] = useState("");
    const [loading, setLoading] = useState(false);
    // Add at the top with other states
    const [categories, setCategories] = useState([]);
    const markerIcon = new L.Icon({
        iconUrl: "https://cdn-icons-png.flaticon.com/512/684/684908.png",
        iconSize: [30, 30],
    });

    // form data
    const [form, setForm] = useState({
        catagory: "",
        keywords: "",
        title: "",
        mobile: "",
        email: "",
        website: "",
        province: "",
        district: "",
        muncipality: "",
        ward: "",
        addresses: "",
        longitude: "",
        latitude: "",
        linkfacebook: "",
        linktwitter: "",
        linkinstagram: "",
        linklinkedin: "",
        descriptions: "",
        profilepics: null, // File
    });

    // FULL VALIDATION — all fields mandatory in every step
    const validateStep = () => {
        let errors = [];

        // -------------------- STEP 1 --------------------
        if (step === 1) {
            if (!form.catagory.trim()) errors.push("Business Category is required");
            if (!form.keywords.trim()) errors.push("Keywords are required");
            if (!form.title.trim()) errors.push("Business Name is required");

            if (form.title.trim().length < 3)
                errors.push("Business Name must be at least 3 characters");
        }

        // -------------------- STEP 2 --------------------
        if (step === 2) {
            // Mobile mandatory + format (ALL Nepal formats)
            if (!form.mobile.trim()) {
                errors.push("Mobile Number is required");
            } else if (
                !/^(?:\+977[-\s]?)?(96|97|98)\d{1}([-\s]?\d{3})([-\s]?\d{4})$/.test(
                    form.mobile.trim()
                )
            ) {
                errors.push("Invalid Mobile Number format");
            }


            // Email mandatory + valid
            if (!form.email.trim()) {
                errors.push("Email is required");
            } else if (!/^[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$/.test(form.email)) {
                errors.push("Invalid Email Address");
            }

            // Mandatory Dropdowns
            if (!form.province) errors.push("Province is required");
            if (!form.district) errors.push("District is required");
            if (!form.muncipality) errors.push("Municipality is required");

            // Ward
            if (!form.ward.trim()) {
                errors.push("Ward Number is required");
            } else if (!/^[0-9]{1,2}$/.test(form.ward)) {
                errors.push("Ward Number must be 1–99");
            }

            // Address required
            if (!form.addresses.trim()) errors.push("Address is required");

            // Map coords
            if (!form.longitude.trim()) errors.push("Longitude is required");
            if (!form.latitude.trim()) errors.push("Latitude is required");
        }

        // -------------------- STEP 3 --------------------
        if (step === 3) {
            if (!form.descriptions.trim())
                errors.push("Business Description is required");

            if (form.descriptions.trim().length < 20)
                errors.push("Description must be at least 20 characters");

            if (!form.profilepics)
                errors.push("Business Profile Picture is required");
        }

        // -------------------- ALERT IF ERRORS --------------------
        if (errors.length > 0) {
            Swal.fire({
                icon: "warning",
                title: "Please fill all required fields",
                html: `<ul style='text-align:left;'>${errors
                    .map(e => `<li>${e}</li>`)
                    .join("")}</ul>`,
                confirmButtonColor: "#3559E0",
            });
            return false;
        }

        return true;
    };
    // Prevent Enter key from skipping steps
    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            if (!validateStep()) return;  // still show validation alert
            if (step < 3) nextStep();     // go next safely
        }
    };

    // progress controls
    const nextStep = () => {
        if (!validateStep()) return;
        setStep((s) => Math.min(s + 1, 3));
    };

    const prevStep = () => setStep((s) => Math.max(s - 1, 1));
    // location dropdown options
    const [provinces, setProvinces] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [muncipalities, setMuncipalities] = useState([]);

    useEffect(() => {
        fetchProvinces();

        fetchCategories(); // new
    }, []);

    const fetchCategories = async () => {
        try {
            const res = await fetch(`${API_BASE}/api/configcategories.php`);
            const data = await res.json();
            if (Array.isArray(data.categories)) {
                setCategories(data.categories);
            }
        } catch (err) {
            console.error("Categories API Error:", err);
            setCategories([]);
        }
    };
    const handleCategoryChange = async (value) => {
        setForm((p) => ({ ...p, catagory: value }));
        try {
            const resp = await fetch(`${API_BASE}/api/configcategories.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ catagory: value }),
            });
            if (resp.ok) {
                const data = await resp.json();
                setForm((p) => ({ ...p, keywords: data.keywords || "" }));
            }
        } catch (err) {
            console.error("Keywords API Error:", err);
        }
    };

    // Load provinces on mount
    useEffect(() => {
        fetchProvinces();

    }, []);


    // Fetch provinces
    const fetchProvinces = async () => {
        try {
            const res = await fetch(`${API_BASE}/api/provinces.php`);
            const data = await res.json();

            if (Array.isArray(data.provinces)) {
                // store full object (id + name)
                setProvinces(data.provinces);
            } else {
                setProvinces([]);
            }
        } catch (err) {
            console.error("Province API Error:", err);
            setProvinces([]);
        }
    };


    // When province changes -> fetch districts
    const handleProvinceChange = async (value) => {
        setForm((p) => ({ ...p, province: value, district: "", muncipality: "" }));
        setDistricts([]);
        setMuncipalities([]);

        try {
            const res = await fetch(`${API_BASE}/api/districts.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ province_id: value }), // send ID
            });

            const data = await res.json();
            if (Array.isArray(data.districts)) {
                setDistricts(data.districts);
            } else {
                setDistricts([]);
            }
        } catch (err) {
            console.error("District API Error:", err);
            setDistricts([]);
        }
    };



    // When district changes -> fetch municipalities
    const handleDistrictChange = async (value) => {
        setForm((p) => ({ ...p, district: value, muncipality: "" }));
        setMuncipalities([]);

        try {
            const res = await fetch(`${API_BASE}/api/muncipality.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ district: value }),
            });

            if (!res.ok) throw new Error("Network response not ok");

            const data = await res.json();
            if (Array.isArray(data.municipalities)) {
                setMuncipalities(data.municipalities);
            }
        } catch (err) {
            console.error("Municipality API Error:", err);
            setMuncipalities([]);
        }
    };




    // generic input handler
    const handleChange = (e) => {
        const { name, value, type } = e.target;
        if (type === "file") {
            setForm((p) => ({ ...p, [name]: e.target.files[0] || null }));
        } else {
            setForm((p) => ({ ...p, [name]: value }));
        }
    };

    const [locationAsked, setLocationAsked] = useState(false);

    useEffect(() => {
        if (step === 2 && !locationAsked) {
            getLocation();
            setLocationAsked(true);
        }
    }, [step]);

    // Geolocation logic (auto fills latitude & longitude but user can edit)
    let allowGeoRecall = true;
    let countLocationAttempts = 0;

    const getLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(showPosition, positionError);
        } else {
            alert(
                "Geolocation is not supported by this device. Please enable location permission."
            );
        }
    };

    function positionError() {
        alert(
            "Geolocation is not enabled. Please enable to autofill Longitudes and Latitudes."
        );
        // don't block user, allow manual input
        if (allowGeoRecall && countLocationAttempts < 2) {
            countLocationAttempts += 1;
            getLocation();
        }
    }

    function showPosition(position) {
        const xlatitude = position.coords.latitude;
        const xlongitude = position.coords.longitude;
        setForm((p) => ({ ...p, latitude: xlatitude.toString(), longitude: xlongitude.toString() }));
        allowGeoRecall = false;
    }
    const showToast = (message, icon) => {
        Swal.fire({
            toast: true,
            position: "top-end",
            icon: icon,
            title: message,
            showConfirmButton: false,
            timer: 1500,
            customClass: {
                popup:
                    icon === "success"
                        ? "my-toast my-toast-success"
                        : icon === "error"
                            ? "my-toast my-toast-error"
                            : "my-toast my-toast-warning",
            },
        });
    };

    // Submit handler - prepares FormData and posts (replace endpoint)
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateStep()) return;
        if (loading) return;
        setLoading(true);

        // Convert IDs → Names
        if (form.province) {
            const prov = provinces.find(p => p.id === form.province);
            if (prov) form.province = prov.provinceName;
        }

        if (form.district) {
            const dist = districts.find(d => d.id === form.district);
            if (dist) form.district = dist.districtName;
        }

        const formData = new FormData();
        Object.entries(form).forEach(([key, value]) => {
            if (key === "provinceId" || key === "districtId" || key === "muncipalityId") {
                return;
            }
            formData.append(key, value ?? "");
        });

        formData.append("personaluid", userData.personaluid);

        try {
            const response = await fetch(`${API_BASE}/api/submitListing.php`, {
                method: "POST",
                body: formData,
            });

            const result = await response.json();
            console.log("Server Response:", result);

            if (result.status === true) {
                // ✅ Small green toast
                showToast("Listing Submitted Successfully!", "success");

                // Auto reload
                setTimeout(() => window.location.reload(), 1800);
            } else {
                // ❌ Error toast
                showToast(result.message || "Submission failed.", "error");
            }

        } catch (error) {
            showToast("Server error! Please try again.", "error");
        }

        setLoading(false);
    };


    function MapClickHandler() {
        useMapEvents({
            click(e) {
                setForm({ ...form, latitude: e.latlng.lat.toString(), longitude: e.latlng.lng.toString() });
            },
        });
        return null;
    }


    return (
        <div className="d-flex flex-column min-vh-100 bg-light">
            <Navbar />

            <div className="container my-5">
                <div className="p-4 p-md-5 shadow-lg rounded-4 bg-white">
                    {/* ----------- STEP PROGRESS BAR ----------- */}
                    <div className="d-flex justify-content-center align-items-center mb-5">
                        {/* STEP 1 */}
                        <div className="text-center">
                            <div
                                className={`rounded-circle mx-auto d-flex justify-content-center align-items-center fw-bold 
                                ${step >= 1 ? "bg-primary text-white" : "bg-light border"} `}
                                style={{ width: 45, height: 45 }}
                            >
                                1
                            </div>
                            <small className="fw-bold mt-2 d-block">Step 1</small>
                        </div>

                        {/* LINE 1 */}
                        <div
                            className={`flex-grow-1 mx-2 ${step >= 2 ? "bg-primary" : "bg-secondary"}`}
                            style={{ height: 3 }}
                        ></div>

                        {/* STEP 2 */}
                        <div className="text-center">
                            <div
                                className={`rounded-circle mx-auto d-flex justify-content-center align-items-center fw-bold 
                                ${step >= 2 ? "bg-primary text-white" : "bg-light border"} `}
                                style={{ width: 45, height: 45 }}
                            >
                                2
                            </div>
                            <small className="fw-bold mt-2 d-block">Step 2</small>
                        </div>

                        {/* LINE 2 */}
                        <div
                            className={`flex-grow-1 mx-2 ${step >= 3 ? "bg-primary" : "bg-secondary"}`}
                            style={{ height: 3 }}
                        ></div>

                        {/* STEP 3 */}
                        <div className="text-center">
                            <div
                                className={`rounded-circle mx-auto d-flex justify-content-center align-items-center fw-bold 
                                ${step >= 3 ? "bg-primary text-white" : "bg-light border"} `}
                                style={{ width: 45, height: 45 }}
                            >
                                3
                            </div>
                            <small className="fw-bold mt-2 d-block">Step 3</small>
                        </div>
                    </div>

                    {/* ----------- PAGE TITLE ----------- */}
                    <h2 className="fw-bold text-center mb-4" style={{ color: "#3559E0" }}>
                        List Your Business
                    </h2>

                    <form onSubmit={handleSubmit} onKeyDown={handleKeyDown} encType="multipart/form-data" autoComplete="off">
                        {/* ---------------------- STEP 1 CONTENT ---------------------- */}
                        {step === 1 && (
                            <>
                                <h5 className="fw-bold mb-3 text-primary">Business Information</h5>

                                <div className="row g-4">
                                    <div className="col-md-6">
                                        <label className="form-label fw-semibold">Business Category *</label>
                                        <select
                                            name="catagory"
                                            className="form-control shadow-sm rounded-3"
                                            value={form.catagory}
                                            onChange={(e) => handleCategoryChange(e.target.value)}
                                            required
                                        >
                                            <option value="">Choose...</option>
                                            {categories.map((c) => (
                                                <option key={c.id} value={c.catagories}>
                                                    {c.catagories}
                                                </option>
                                            ))}
                                        </select>

                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label fw-semibold">Keywords *</label>
                                        <textarea
                                            name="keywords"
                                            className="form-control shadow-sm rounded-3"
                                            placeholder="Please enter keywords separated by commas along with space"
                                            rows="1"
                                            pattern="^[\w\s,]+$"
                                            value={form.keywords}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="col-md-12">
                                        <label className="form-label fw-semibold">Business Name *</label>
                                        <input
                                            type="text"
                                            name="title"
                                            className="form-control shadow-sm rounded-3"
                                            placeholder="Listing Title (Business Name / Your Full Name)"
                                            value={form.title}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="text-end mt-4">
                                    <button
                                        type="button"
                                        className="btn btn-primary px-4 py-2 rounded-4"
                                        onClick={nextStep}

                                    >
                                        Continue → Step 2
                                    </button>
                                </div>


                            </>
                        )}

                        {/* ---------------------- STEP 2 CONTENT ---------------------- */}
                        {step === 2 && (
                            <>
                                <h5 className="fw-bold mb-3 text-primary">Contact Details</h5>

                                <div className="row g-4">
                                    <div className="col-md-4">
                                        <label className="form-label fw-semibold">Mobile Number *</label>
                                        <input
                                            type="text"
                                            name="mobile"
                                            className="form-control shadow-sm rounded-3"
                                            placeholder="Mobile Number"
                                            pattern="^(96|97|98)[0-9]{8}$"
                                            value={form.mobile}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label className="form-label fw-semibold">Email *</label>
                                        <input
                                            type="email"
                                            name="email"
                                            className="form-control shadow-sm rounded-3"
                                            placeholder="example@gmail.com"
                                            pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$"
                                            value={form.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label className="form-label fw-semibold">Website</label>
                                        <input
                                            type="url"
                                            name="website"
                                            className="form-control shadow-sm rounded-3"
                                            placeholder="https://yourwebsite.com"
                                            value={form.website}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                {/* Location */}
                                <h5 className="fw-bold mt-5 mb-3 text-primary">Location</h5>

                                <div className="row g-4">
                                    <div className="col-md-3">
                                        <label className="form-label fw-semibold">Province *</label>
                                        <select
                                            name="province"
                                            className="form-control shadow-sm rounded-3"
                                            value={form.province}
                                            onChange={(e) => handleProvinceChange(e.target.value)}
                                            required
                                        >
                                            <option value="">Select Province</option>
                                            {provinces.map((p) => (
                                                <option key={p.id} value={p.id}>
                                                    {p.provinceName}
                                                </option>
                                            ))}
                                        </select>






                                    </div>

                                    <div className="col-md-4">
                                        <label className="form-label fw-semibold">District *</label>
                                        <select
                                            name="district"
                                            className="form-control shadow-sm rounded-3"
                                            value={form.district}
                                            onChange={(e) => handleDistrictChange(e.target.value)}
                                            required
                                        >
                                            <option value="">
                                                {districts.length ? "Choose District" : "Select Province First"}
                                            </option>

                                            {districts.map((d) => (
                                                <option key={d.id} value={d.id}>
                                                    {d.districtName} {/* ✅ Only render string, not object */}
                                                </option>
                                            ))}
                                        </select>





                                    </div>

                                    <div className="col-md-3">
                                        <label className="form-label fw-semibold">Muncipality *</label>
                                        <select
                                            name="muncipality"
                                            className="form-control shadow-sm rounded-3"
                                            value={form.muncipality} // display name
                                            onChange={(e) => {
                                                const selected = muncipalities.find(m => m.municipalityName === e.target.value);
                                                if (selected) {
                                                    setForm((p) => ({
                                                        ...p,
                                                        muncipality: selected.municipalityName, // display & save
                                                        muncipalityId: selected.id,             // internal ID
                                                    }));
                                                }
                                            }}
                                            required
                                        >
                                            <option value="">
                                                {muncipalities.length ? "Choose Municipality" : "Select District First"}
                                            </option>
                                            {muncipalities.map((m) => (
                                                <option key={m.id} value={m.municipalityName}>
                                                    {m.municipalityName}
                                                </option>
                                            ))}
                                        </select>




                                    </div>

                                    <div className="col-md-2">
                                        <label className="form-label fw-semibold">Ward No. *</label>
                                        <input
                                            type="text"
                                            name="ward"
                                            className="form-control form-control-sm shadow-sm rounded-3"
                                            placeholder="Ward No."
                                            pattern="[0-9]{1,2}"
                                            value={form.ward}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="row g-4 mt-2">
                                    <div className="col-md-12">
                                        <label className="form-label fw-semibold">Address *</label>
                                        <textarea
                                            name="addresses"
                                            className="form-control form-control-sm shadow-sm rounded-3"
                                            placeholder="Address"
                                            pattern="^[A-Za-z0-9\s\.,#-]+$"
                                            value={form.addresses}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="row g-4 mt-2">
                                    <div className="col-md-6">
                                        <label className="form-label fw-semibold">Longitude *</label>
                                        <input
                                            type="text"
                                            name="longitude"
                                            className="form-control form-control-sm shadow-sm rounded-3"
                                            placeholder="Longitude"
                                            value={form.longitude}
                                            onChange={(e) =>
                                                setForm({ ...form, longitude: e.target.value })
                                            }
                                            required
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label fw-semibold">Latitude *</label>
                                        <input
                                            type="text"
                                            name="latitude"
                                            className="form-control form-control-sm shadow-sm rounded-3"
                                            placeholder="Latitude"
                                            value={form.latitude}
                                            onChange={(e) =>
                                                setForm({ ...form, latitude: e.target.value })
                                            }
                                            required
                                        />
                                    </div>
                                </div>

                                {/* MAP */}
                                <div className="mt-3">
                                    <label className="form-label fw-semibold">Select Location on Map (Optional)</label>
                                    <MapContainer
                                        center={[
                                            form.latitude || 27.7172,
                                            form.longitude || 85.3240,
                                        ]}
                                        zoom={13}
                                        scrollWheelZoom={true}
                                        style={{ height: "300px", width: "100%" }}
                                    >
                                        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                                        <MapClickHandler />

                                        {form.latitude && form.longitude && (
                                            <Marker
                                                position={[form.latitude, form.longitude]}
                                                icon={markerIcon}
                                            />
                                        )}
                                    </MapContainer>
                                </div>


                                <div className="d-flex justify-content-between mt-4">
                                    <button className="btn btn-secondary px-4 py-2 rounded-4" type="button" onClick={prevStep}>
                                        ← Back
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary px-4 py-2 rounded-4"
                                        onClick={() => {
                                            if (validateStep()) nextStep();
                                        }}
                                    >
                                        Continue → Step 3
                                    </button>

                                </div>
                            </>
                        )}

                        {/* ---------------------- STEP 3 CONTENT ---------------------- */}
                        {step === 3 && (
                            <>
                                <h5 className="fw-bold mb-3 text-primary">Online Presence</h5>

                                <div className="row g-4">
                                    <div className="col-md-6">
                                        <label className="form-label fw-semibold">Facebook</label>
                                        <input
                                            type="text"
                                            name="linkfacebook"
                                            className="form-control shadow-sm rounded-3"
                                            placeholder="Your facebook link"
                                            pattern="^https:\/\/(www\.)?facebook\.com\/[a-zA-Z0-9.]+$"
                                            value={form.linkfacebook}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label fw-semibold">Twitter</label>
                                        <input
                                            type="text"
                                            name="linktwitter"
                                            className="form-control shadow-sm rounded-3"
                                            placeholder="Your twitter link"
                                            pattern="^https:\/\/(www\.)?twitter\.com\/[a-zA-Z0-9_]+$"
                                            value={form.linktwitter}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                <div className="row g-4 mt-2">
                                    <div className="col-md-6">
                                        <label className="form-label fw-semibold">Instagram</label>
                                        <input
                                            type="text"
                                            name="linkinstagram"
                                            className="form-control shadow-sm rounded-3"
                                            placeholder="Your instagram link"
                                            pattern="^https:\/\/(www\.)?instagram\.com\/[a-zA-Z0-9_\.]+$"
                                            value={form.linkinstagram}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label fw-semibold">LinkedIn</label>
                                        <input
                                            type="text"
                                            name="linklinkedin"
                                            className="form-control shadow-sm rounded-3"
                                            placeholder="Your linkedin link"
                                            pattern="^https:\/\/(www\.)?linkedin\.com\/in\/[a-zA-Z0-9-]+$"
                                            value={form.linklinkedin}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                <h5 className="fw-bold mt-5 mb-3 text-primary">Upload Logo</h5>

                                <div className="col-md-12">
                                    <label className="form-label fw-semibold">Profile Picture / Business Logo *</label>
                                    <input
                                        type="file"
                                        name="profilepics"
                                        className="form-control shadow-sm rounded-3"
                                        accept="image/*"
                                        onChange={handleChange}
                                        required
                                    />
                                    <small className="text-muted">Recommended: 800 × 600px</small>
                                </div>

                                <div className="row g-4 mt-2">
                                    <div className="form-group col-md-12">
                                        <label className="form-label fw-semibold">Descriptions *</label>
                                        <textarea
                                            name="descriptions"
                                            className="form-control form-control-sm shadow-sm rounded-3"
                                            placeholder="Descriptions"
                                            pattern="^[a-zA-Z0-9\s.,!?()'-]+$"
                                            value={form.descriptions}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="d-flex justify-content-between mt-4">
                                    <button className="btn btn-secondary px-4 py-2 rounded-4" type="button" onClick={prevStep}>
                                        ← Back
                                    </button>
                                    <button
                                        className="btn px-4 py-2 rounded-4 text-white"
                                        style={{ background: "#3559E0", fontWeight: "bold" }}
                                        type="submit"
                                    >
                                        Submit Listing
                                    </button>
                                </div>
                            </>
                        )}
                    </form>
                </div>
                {/* SMALL TOAST CSS */}
                <style>{`
                .small-swal {
                    padding: 6px 12px !important;
                    font-size: 14px !important;
                    border-radius: 6px !important;
                    min-height: 40px !important;
                }
                    .my-toast {
                    padding: 10px 16px !important;
                    font-size: 15px !important;
                    border-radius: 8px !important;
                    min-height: 45px !important;
                    box-shadow: 0px 3px 10px rgba(0,0,0,0.15) !important;
                }

                .my-toast-success {
                    background: #d4f8d4 !important;
                    border-left: 5px solid #28a745 !important;
                    color: #155724 !important;
                }

                .my-toast-error {
                    background: #fde2e2 !important;
                    border-left: 5px solid #dc3545 !important;
                    color: #721c24 !important;
                }

                .my-toast-warning {
                    background: #fff3cd !important;
                    border-left: 5px solid #ff9800 !important;
                    color: #7a5200 !important;
                }

                            `}</style>
            </div>

            <br />
            <br />
            <br />
            <br />
            <Footer />
        </div>
    );
}

export default BusinessListing;
